import { getFormattedNumber } from './util.js';

/**
 * Функция преобразует количество денег,
 * которое указано в копейках или центах, 
 * в строку.
 *
 * Примеры
 *      1 ->     '0.01'
 *     10 ->     '0.10'
 *    100 ->     '1.00' 
 *    150 ->     '1.50'
 * 100000 -> '1 000.00'
 *
 * @param {number} moneyAmount
 * @returns {string}
 */
export function convertCentToString(moneyAmount) {
  const quotient = Math.floor(moneyAmount / 100);
  const remainder = moneyAmount % 100;

  const intPartStr = getFormattedNumber(quotient);
  const fractionalPartStr = remainder.toString().padStart(2, '0');
  return intPartStr + '.' + fractionalPartStr;
}
